import { nbVal, strVal, strValOrUndef } from "@paroi/data-formatters-lib";

export interface Log {
  id: number;
  action: string;
  description: string;
  type: string;
  author: Author;
  userAgent: string;
  route: string;
  referrer?: string;
  method: string;
  lang: string;
  ip: string;
  responseStatus: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

interface Author {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
}

export function formatLog(data: any): Log {
  return {
    id: nbVal(data.id),
    action: strVal(data.action),
    description: strVal(data.description),
    author: formatAuthor(data.author),
    ip: strVal(data.ip),
    lang: strVal(data.lang),
    method: strVal(data.method),
    responseStatus: strVal(data.response_status),
    route: strVal(data.route),
    type: strVal(data.type),
    userAgent: strVal(data.user_agent),
    referrer: strValOrUndef(data.referrer),
    createdAt: strVal(data.created_at),
    updatedAt: strVal(data.updated_at),
    deletedAt: strValOrUndef(data.deleted_at),
  };
}

function formatAuthor(data: any): Author {
  return {
    id: nbVal(data.id),
    firstname: strVal(data.firstname),
    lastname: strVal(data.lastname),
    email: strVal(data.email),
  };
}
